<div class="graphic">
    <canvas
        baseChart
        class="graphic"
        [data]="doughnutChartData"
        [labels]="doughnutChartLabels"
        [chartType]="doughnutChartType"
        [legend]="barChartLegend"
    >
    </canvas>
</div>
